import { Box, Grid, TextField, Typography, Button, Input } from '@mui/material'
import ModalRequest from '../../../components/ModalRequest'
import { useEffect, useState } from 'react'
import axiosInstance from '../../../config/axiosConfig'
import { urlConfig } from '../../../config/apiConfig'

export default function SoundForm({
    open,
    setOpen,
    row,
    handleAlert,
    refresh,
}) {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState({
        name: '',
        sound: null,
    })

    const onSubmit = async () => {
        try {
            if (!data.name && !row) {
                handleAlert('Please enter a sound name', 'error')
                return
            }
            if (!data.sound && !row) {
                handleAlert('Please select a sound file', 'error')
                return
            }
            setLoading(true)
            const formData = new FormData()
            formData.append('name', data.name)
            if (data.sound instanceof File) {
                formData.append('sound', data.sound)
            }

            if (row) {
                await axiosInstance.put(
                    `${urlConfig.sound}/${row.sound_id}`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    },
                )
                handleAlert('Edit Notification sound', 'success')
            } else {
                await axiosInstance.post(urlConfig.sound, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                handleAlert('Add New Notification sound', 'success')
            }
            setOpen(false)
            refresh()
            setData({ name: '', sound: null })
        } catch (error) {
            handleAlert(
                error.response?.data?.message || 'Failed to save sound',
                'error',
            )
        } finally {
            setLoading(false)
        }
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0]
        if (file) {
            setData({
                ...data,
                sound: file,
            })
        }
    }

    const handleRemoveFile = () => {
        setData({
            ...data,
            sound: null,
        })
    }

    useEffect(() => {
        if (row) {
            setData({
                name: row?.name || '',
                sound:
                    {
                        name: row?.file_name,
                        type: 'audio/mpeg',
                    } || null,
            })
        } else {
            setData({
                name: '',
                sound: null,
            })
        }
    }, [row, open])

    return (
        <ModalRequest
            width='600px'
            disabled={loading}
            open={open}
            setOpen={setOpen}
            title={
                row ? 'Edit Notification sound' : 'Add New Notification sound'
            }
            onSubmit={onSubmit}
        >
            <Grid item xs={12} mt={1}>
                <TextField
                    size='small'
                    fullWidth
                    label='Sound Name'
                    name='name'
                    value={data?.name || ''}
                    onChange={(e) =>
                        setData({
                            ...data,
                            name: e.target.value,
                        })
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <Typography fontWeight={600}>Upload Files</Typography>
                <Typography>
                    {data?.sound instanceof File
                        ? data.sound.name
                        : data?.sound?.name || ''}
                </Typography>
                <Box
                    sx={{
                        width: '100%',
                        bgcolor: '#F0F0F0',
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: 4,
                        flexDirection: 'column',
                        gap: 2,
                        mt: data?.sound ? 2 : 0,
                    }}
                >
                    <Typography>File Supported. WAV MP3</Typography>

                    {data?.sound ? (
                        <Button
                            variant='contained'
                            onClick={handleRemoveFile}
                            sx={{ color: 'primary.lightest' }}
                        >
                            Clear File
                        </Button>
                    ) : (
                        <Button
                            variant='contained'
                            component='label'
                            color='info'
                            sx={{
                                color: 'primary.lightest',
                            }}
                        >
                            Choose File
                            <Input
                                sx={{ display: 'none' }}
                                inputProps={{
                                    accept: '.wav,.mp3',
                                    type: 'file',
                                }}
                                onChange={handleFileChange}
                            />
                        </Button>
                    )}
                </Box>
            </Grid>
        </ModalRequest>
    )
}
